import { Component, OnInit, ChangeDetectorRef, AfterContentChecked,Renderer2,Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { ConfigService, DatastoreService, CommonFunctionsService, NotificationStoreService, ApiService } from '../app/services/index'
import { TranslateService } from '@ngx-translate/core';
import { filter, Observable, timer } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { TranslatorService } from './services/translator.service';
import { ActivatedRoute } from '@angular/router';
import { CommunicationService } from './services/communication.service';
import { initAll } from 'govuk-frontend';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterContentChecked {

  title = 'my-ceremonies-app';
  favIcon: HTMLLinkElement = document.querySelector('#appIcon') as HTMLLinkElement;
  errors: any = [];
  loadIssue = false;
  connectionIssue = false;
  config: any;
  everySecond: Observable<any> = timer(0, 1000);
  countDown = 10;
  startTime = false;

  constructor(
    private configService: ConfigService,
    private titleService: Title,
    private translate: TranslateService,
    public translatorService: TranslatorService,
    public dataStore: DatastoreService,
    private commonFunctionsService: CommonFunctionsService,
    private apiService: ApiService,
    private notifStore: NotificationStoreService,
    private router: Router,
    private cdref: ChangeDetectorRef,
    private route: ActivatedRoute,
    private comms: CommunicationService
  ) {
    translate.setDefaultLang('en');
  }

  ngAfterContentChecked(): void {
    this.cdref.detectChanges();
  }

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects || event.url;
        const lastSegment = url.split('/').filter(Boolean).pop();
        const formatted = lastSegment.replace(/[-_]/g, ' ')
          .replace(/\b\w/g, char => char.toUpperCase());
        this.titleService.setTitle(`${formatted} | Westminster - a day to remember`);

        if (!url.includes('access')) {
          setTimeout(() => {
            const main = document.getElementById('main-content');
            main?.focus();
          }, 0);
        }
      });

    // this.getConfig();
    this.everySecond.subscribe((seconds: any) => {
      if (this.dataStore.timer) {
        this.startTime = true;
      } else this.startTime = false;
    });

    this.commonFunctionsService.getRequestError().subscribe((err: any) => {
      if (err) {
        this.loadIssue = true;
        if (err.status === 0) {
          this.connectionIssue = true;
        }
        this.errors.push(err.message);
      } else {
        this.errors = [];
        this.loadIssue = false;
      }
    });
    this.comms.pollForMessages();

    // const wa = setInterval(() => {
    //   this.commonFunctionsService.fontChecker()
    // }, 500);

    // init gov compoents
    initAll();
  }

  redirect() {
    this.commonFunctionsService.newBooking();
    this.router.navigate([`/access`]);
  }

  async getConfig() {
    this.config = await this.configService.getConfig();

    const companyConfig = JSON.stringify(this.config);
    const current = sessionStorage.getItem("config");
    if(current !== companyConfig){ 
      sessionStorage.setItem("config", companyConfig);
      location.reload(); // this lets the routes get updated based on the info in the config
    }
    this.commonFunctionsService.setConfig(companyConfig);
    this.dataStore.config = companyConfig;
    // this.dataStore.config.requireLogin = JSON.parse(companyConfig).requireLogn;
    this.dataStore.company = await this.apiService.getCompany(this.config.company);
    console.log("company", this.dataStore.company)
    // let the rest of the app know
    this.notifStore.onsessionUpdate(true);
    return this.config;
  }

  skipToMainContent(event: Event) {
    event.preventDefault(); // Prevent default anchor behavior
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
    }
  }

  isLoggedIn() {
    if(this.dataStore.config){
    const requireLogin = JSON.parse(this.dataStore.config).requireLogin;
    return this.dataStore.loggedIn && !(this.router.url === "/account" && !requireLogin);
    } else return false
  }

  resetApp() {
    location.reload();
  }

  
}
